import gql from 'graphql-tag'

export const GET_APP_SETTINGS_QUERY = gql`
  query getAppSettings {
    AppSettings {
      isUnderMaintenance
    }
  }
`
